import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/ui/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h3 {...{
      "id": "overview"
    }}>{`Overview`}</h3>
    <blockquote>
      <p parentName="blockquote">{`Coming soon`}</p>
    </blockquote>
    <h3 {...{
      "id": "search-interface"
    }}>{`Search interface`}</h3>
    <h3 {...{
      "id": "search-results-and-snippets"
    }}>{`Search results and snippets`}</h3>
    <h3 {...{
      "id": "default-algorithm"
    }}>{`Default algorithm`}</h3>
    <h3 {...{
      "id": "custom-algorithm"
    }}>{`Custom algorithm`}</h3>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      